module.exports = "/assets/6dff59259d1f5741ae757468cc85d153.png";